import React from 'react';

import ClientsList from '../../components/Admin/ClientsList';

function ClientsListView() {
  return (
    <ClientsList />
  );
}

export default ClientsListView;
